import Section, { SectionHeading } from '@/components/Section';
import Reveal from '@/components/Reveal';
import { PROCESS_STEPS } from '@/data/content';

export default function Process() {
  return (
    <Section id="kako-radimo" tone="paper">
      <SectionHeading eyebrow="Kako radimo" title="Od upita do montaže u četiri koraka." />
      <ol className="mt-14 grid gap-10 sm:grid-cols-2 lg:grid-cols-4 lg:gap-8">
        {PROCESS_STEPS.map((step, i) => (
          <li key={step.title}>
            <Reveal delay={i * 0.08}>
              <div className="border-t-2 border-ink pt-5">
                <span
                  className="text-5xl text-brand"
                  style={{ fontFamily: "'Archivo Black', 'Outfit', sans-serif" }}
                  aria-hidden="true"
                >
                  {i + 1}
                </span>
                <h3 className="mt-4 text-xl leading-snug">
                  <span className="sr-only">Korak {i + 1}: </span>
                  {step.title}
                </h3>
                <p className="mt-3 text-ink/75 leading-relaxed">{step.text}</p>
              </div>
            </Reveal>
          </li>
        ))}
      </ol>
    </Section>
  );
}
